var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBasisBrandEinbruchschutz = function SvgBasisBrandEinbruchschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.464,
    height: 71.525
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__f",
    x1: 27.011,
    x2: 25.874,
    y1: 66.654,
    y2: 2.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f17011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#f79f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fbc15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fed673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__g",
    x1: 32.518,
    x2: 18.669,
    y1: 60.937,
    y2: 9.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f3811d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fed564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__i",
    x1: 43.875,
    x2: 32.577,
    y1: 33.573,
    y2: 45.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59797f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0b2b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__j",
    x1: 37.039,
    x2: 30.612,
    y1: 28.439,
    y2: 45.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__b",
    x1: 31.736,
    x2: 45.088,
    y1: 34.983,
    y2: 44.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__b",
    id: "basis-brand-einbruchschutz_svg__k",
    x1: 34.372,
    x2: 41.64,
    y1: 30.773,
    y2: 36.507
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__c",
    x1: 10.891,
    x2: 19.057,
    y1: 31.055,
    y2: 32.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__c",
    id: "basis-brand-einbruchschutz_svg__l",
    x1: 55.749,
    x2: 60.744,
    y1: 38.852,
    y2: 39.584
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__c",
    id: "basis-brand-einbruchschutz_svg__m",
    x1: 29.005,
    x2: 45.616,
    y1: 32.664,
    y2: 35.097
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__c",
    id: "basis-brand-einbruchschutz_svg__n",
    x1: 15.926,
    x2: 31.761,
    y1: 31.119,
    y2: 33.439
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__c",
    id: "basis-brand-einbruchschutz_svg__o",
    x1: 41.448,
    x2: 55.029,
    y1: 35.785,
    y2: 37.774
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__p",
    x1: 43.546,
    x2: 36.184,
    y1: 67.37,
    y2: 10.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#ef6001",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#f48b2b",
    stopOpacity: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#fab856",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#fed370",
    stopOpacity: 0.132
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__f",
    id: "basis-brand-einbruchschutz_svg__r",
    x1: 46.792,
    x2: 45.871,
    y1: 67.095,
    y2: 15.545
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__g",
    id: "basis-brand-einbruchschutz_svg__s",
    x1: 45.473,
    x2: 52.469,
    y1: 60.763,
    y2: 9.213
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__t",
    x1: 45.179,
    x2: 48.098,
    y1: 69.684,
    y2: 28.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__h",
    x1: 65.139,
    x2: -2.98,
    y1: 58.673,
    y2: 59.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dba283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__h",
    id: "basis-brand-einbruchschutz_svg__u",
    x1: 0.846,
    x2: 72.618,
    y1: 58.764,
    y2: 58.764
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basis-brand-einbruchschutz_svg__v",
    x1: 32.452,
    x2: 40.984,
    y1: 61.067,
    y2: 53.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dba283"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf8364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#basis-brand-einbruchschutz_svg__c",
    id: "basis-brand-einbruchschutz_svg__w",
    x1: 39.965,
    x2: 31.231,
    y1: 58.068,
    y2: 54.954
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "basis-brand-einbruchschutz_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M56.472 33.938s2.453 14.71-4.64 17.887c2.628-6.686 1.755-18.042-4.214-26.772-8.072-10.538-6.053-18.519-6.053-18.519l-.382.24c-2.411 1.878-8.24 7.862-2.224 18.488 2.688 4.746 3.543 9.014 3.18 12.865-.547 5.836-3.895 10.715-7.91 14.852-.057.058-.105.12-.16.18-.248.263-.49.53-.717.806-.107.132-.202.27-.305.405-.162.212-.326.423-.475.64-.105.155-.198.314-.297.471-.13.206-.262.41-.38.62-.095.169-.179.34-.267.51-.106.205-.212.41-.308.618-.081.178-.153.357-.227.537a15 15 0 0 0-.243.619c-.067.185-.125.37-.184.557q-.098.307-.182.617-.074.285-.137.573a14 14 0 0 0-.212 1.196q-.04.302-.065.603-.025.295-.038.59-.012.297-.008.593-.001.294.014.587.017.292.047.581c.02.195.039.39.067.582.029.19.067.377.104.564.038.192.074.383.121.572.047.184.105.364.16.545.057.185.11.372.176.554.066.18.145.354.22.53.075.175.144.353.228.524.089.181.194.355.294.531.088.157.169.318.266.471a11 11 0 0 0 1.491 1.84 35 35 0 0 0 5.26.524c5.763.148 11.434-2.41 15.882-6.385 9.154-8.176 13.133-22.337 2.118-31.196"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "basis-brand-einbruchschutz_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.023 1.485h43.122v75.04H25.023z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "basis-brand-einbruchschutz_svg__e",
    width: 43.2,
    height: 75.36,
    x: 24.959,
    y: 1.214,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#basis-brand-einbruchschutz_svg__a)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 90,
    height: 157,
    transform: "matrix(.48 0 0 .48 24.959 1.214)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "basis-brand-einbruchschutz_svg__q",
    width: 43.122,
    height: 75.04,
    x: 25.023,
    y: 1.485,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#basis-brand-einbruchschutz_svg__d)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#basis-brand-einbruchschutz_svg__a)",
    mask: "url(#basis-brand-einbruchschutz_svg__e)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAACdCAYAAAA0RW8OAAAACXBIWXMAABcRAAAXEQHKJvM/AAABbUlEQVR4Xu3QoQHAIBDAwNL9d35GwEDUnY7Kmpn5eO4/BdxhdMToiNERoyNGR4yOGB0xOmJ0xOiI0RGjI0ZHjI4YHTE6YnTE6IjREaMjRkeMjhgdMTpidMToiNERoyNGR4yOGB0xOmJ0xOiI0RGjI0ZHjI4YHTE6YnTE6IjREaMjRkeMjhgdMTpidMToiNERoyNGR4yOGB0xOmJ0xOiI0RGjI0ZHjI4YHTE6YnTE6IjREaMjRkeMjhgdMTpidMToiNERoyNGR4yOGB0xOmJ0xOiI0RGjI0ZHjI4YHTE6YnTE6IjREaMjRkeMjhgdMTpidMToiNERoyNGR4yOGB0xOmJ0xOiI0RGjI0ZHjI4YHTE6YnTE6IjREaMjRkeMjhgdMTpidMToiNERoyNGR4yOGB0xOmJ0xOiI0RGjI0ZHjI4YHTE6YnTE6IjREaMjRkeMjhgdMTpidMToiNERoyNGR4yOGB0xOmJ0xOiI0ZEN9HIFNui3w0EAAAAASUVORK5CYII=",
    width: 90,
    height: 157,
    transform: "matrix(.48 0 0 .48 24.959 1.214)"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__f)",
    d: "M34.79 48.797c-6.336 6.528-7.058 16.602-1.255 22.258C15.654 67.848 5.589 53.2 8.995 31.723c1.486 5.95 1.157 9.583 8.922 16.851C12.24 37.361 5.787 20.754 31.613 0c-1.615 3.887-3.467 11.804 3.734 19.005a81.5 81.5 0 0 1 9.218 11.442c-.676 7.21-4.813 13.238-9.775 18.35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__g)",
    d: "M34.791 48.797c-5.721 6.31-6.942 15.331-2.284 21.125C16.95 66.617 8.393 54.38 9.322 37.22c.942 3.549 2.538 6.936 7.97 12.02a.92.92 0 0 0 .627.247.914.914 0 0 0 .813-1.325c-3.031-5.989-5.72-12.578-4.874-20.196.868-7.803 3.904-13.129 10.96-20.303a1.19 1.19 0 0 1 2.025.705c.448 3.356 3.534 6.29 7.857 11.282 2.757 3.183 8.58 8.814 8.973 12.549.139 1.314-.621 7.487-8.882 16.597"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M37.754 71.389S50.31 60.764 54.806 55.445c6.415-7.584 9.61-30.542 7.74-40.282L37.754 8.367 12.962 15.17c-1.87 9.733 1.325 32.691 7.74 40.275 4.494 5.319 17.052 15.944 17.052 15.944"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "M37.326 65.346c-3.782-3.315-10.545-9.367-13.343-12.667-4.625-5.47-7.862-23.377-7.169-33.655l.031-.46 20.909-5.74 20.908 5.733.031.46c.693 10.276-2.543 28.182-7.169 33.652-2.985 3.533-10.326 10.043-13.344 12.677l-.427.373Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M37.754 64.858c-4.314-3.78-10.61-9.453-13.276-12.598-4.535-5.364-7.69-23.212-7.017-33.192l20.293-5.57 20.292 5.562c.673 9.98-2.484 27.829-7.017 33.19-2.668 3.157-8.962 8.841-13.275 12.608"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__i)",
    d: "M45.504 35.756h-1.347v-2.898a6.407 6.407 0 0 0-12.806 0v2.898h-1.347a1.16 1.16 0 0 0-1.16 1.157V46.4a1.16 1.16 0 0 0 1.16 1.159h15.5a1.16 1.16 0 0 0 1.159-1.16v-9.486a1.16 1.16 0 0 0-1.16-1.157m-3.485 0h-8.53v-2.898a4.271 4.271 0 0 1 8.53 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__j)",
    d: "M29.763 47.109v-9.487a1.16 1.16 0 0 1 1.16-1.157h1.346v-2.898a6.306 6.306 0 0 1 6.404-6.188 6.5 6.5 0 0 1 3.51 1.017 6.5 6.5 0 0 0-4.428-1.726 6.306 6.306 0 0 0-6.404 6.188v2.898h-1.347a1.16 1.16 0 0 0-1.16 1.157V46.4a1.16 1.16 0 0 0 1.006 1.147 1.2 1.2 0 0 1-.087-.438"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__b)",
    d: "M37.754 27.024a5.95 5.95 0 0 1 6.048 5.834v3.252h1.701a.805.805 0 0 1 .805.804V46.4a.805.805 0 0 1-.805.805H30.004a.805.805 0 0 1-.804-.805v-9.485a.805.805 0 0 1 .804-.804h1.702v-3.252a5.95 5.95 0 0 1 6.048-5.834m0-.355a6.305 6.305 0 0 0-6.403 6.189v2.897h-1.347a1.16 1.16 0 0 0-1.159 1.16v9.484a1.16 1.16 0 0 0 1.16 1.16h15.498a1.16 1.16 0 0 0 1.16-1.16v-9.485a1.16 1.16 0 0 0-1.16-1.159h-1.347v-2.897a6.305 6.305 0 0 0-6.402-6.188"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__k)",
    d: "M37.755 28.806a4.166 4.166 0 0 1 4.264 4.052v2.898h-8.53v-2.898a4.17 4.17 0 0 1 4.266-4.052m0-.324a4.49 4.49 0 0 0-4.591 4.376v3.222h9.18v-3.222a4.49 4.49 0 0 0-4.59-4.376"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__c)",
    d: "M16.733 23.103c-1.62-.393-3.072-.756-4.3-1.069a87.7 87.7 0 0 0 2.252 18.824q2.141-.623 4.182-1.069a85.5 85.5 0 0 1-2.134-16.686",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__l)",
    d: "M58.297 30.016a77.4 77.4 0 0 1-3.494 16.217 40 40 0 0 1 3.514 2.873 76.5 76.5 0 0 0 4.313-19.124c-1.35.069-2.803.077-4.333.034",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m24.611 53.392-.108-.12c-.184-.204-.36-.405-.52-.593-4.625-5.47-7.862-23.377-7.169-33.655l.031-.46 20-5.49-20.128 5.02-.334.092-.023.345-.031.46c-.699 10.365 2.59 28.452 7.283 34.002a49 49 0 0 0 4.319 3.788c-1.272-1.23-2.423-2.397-3.32-3.389"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__m)",
    d: "M46.175 35.973a1.15 1.15 0 0 0-.672-.218h-1.346v-2.897a6 6 0 0 0-.966-3.24 296 296 0 0 1-9.367-1.625 6.2 6.2 0 0 0-1.308 1.318 6 6 0 0 0-1.165 3.547v2.897h-1.347a1.16 1.16 0 0 0-1.16 1.158v.627a48 48 0 0 1 1.502-.025 42.7 42.7 0 0 1 16.317 3.112v-3.714a1.15 1.15 0 0 0-.488-.94m-4.156-.217h-8.53v-2.898a3.86 3.86 0 0 1 .515-1.93 4.17 4.17 0 0 1 1.367-1.43 4.3 4.3 0 0 1 .725-.373 4.47 4.47 0 0 1 3.317 0 4.3 4.3 0 0 1 .725.374 4.16 4.16 0 0 1 1.366 1.429 3.87 3.87 0 0 1 .515 1.93Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__n)",
    d: "M28.845 36.913a1.16 1.16 0 0 1 1.16-1.158h1.346v-2.897a6 6 0 0 1 1.164-3.547 6.4 6.4 0 0 1 1.87-1.698c-6.317-1.202-12.315-2.558-16.977-3.68a86.7 86.7 0 0 0 1.953 15.092 55 55 0 0 1 9.484-1.16Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__o)",
    d: "M42.8 29.072c.104.13.21.257.303.395a6 6 0 0 1 1.054 3.391v2.897h1.346a1.166 1.166 0 0 1 1.16 1.158v4.039a40.4 40.4 0 0 1 7.815 4.248 78.5 78.5 0 0 0 3.086-14.562A133 133 0 0 1 42.8 29.072",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__p)",
    d: "M58.318 49.105a56 56 0 0 0 2.118-6.665l.002-.005q.302-1.185.572-2.405l.01-.047c.356-1.612.668-3.26.934-4.916l.015-.088q.192-1.198.35-2.395l.028-.209c.872-6.658.987-13.109.199-17.212L37.754 8.367 12.962 15.17a42.7 42.7 0 0 0-.492 8.976l.003.087q.035 1.056.104 2.152l.013.194c.096 1.484.235 3.012.417 4.561l.013.112q.138 1.166.308 2.343l.014.098c.231 1.585.504 3.171.818 4.735l.018.092c1.415 7.015 3.644 13.52 6.524 16.925 4.494 5.319 17.052 15.944 17.052 15.944S50.31 60.764 54.806 55.445a23.2 23.2 0 0 0 3.511-6.34Z",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#basis-brand-einbruchschutz_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__r)",
    d: "M54.354 65.134c-4.448 3.974-10.119 6.533-15.883 6.385a35 35 0 0 1-5.259-.525c-4.696-4.578-4.112-12.731 1.016-18.015 4.016-4.137 7.364-9.016 7.912-14.852.362-3.851-.493-8.119-3.18-12.865-6.016-10.626-.188-16.61 2.223-18.488l.382-.24s-2.019 7.981 6.053 18.519c5.969 8.73 6.842 20.086 4.214 26.772 7.093-3.178 4.64-17.887 4.64-17.887 11.015 8.859 7.036 23.02-2.118 31.196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__s)",
    d: "M53.862 64.581a22.73 22.73 0 0 1-14.916 6.206q-.226 0-.456-.008a34 34 0 0 1-5.146-.512q-.487-.088-.964-.19c-3.77-4.69-2.953-12.152 1.85-17.098 3.846-3.962 7.463-8.672 8.646-14.783.816-4.218-.698-8.753-3.272-13.299C34.646 16.145 38.02 10.76 40.61 8.25c-.148 3.045.454 9.455 6.408 17.236a32.1 32.1 0 0 1 5.197 13.817 25.6 25.6 0 0 1-1.073 12.25.74.74 0 0 0 .69 1.012.7.7 0 0 0 .302-.065c5.969-2.675 5.724-12.458 5.313-16.71A15.78 15.78 0 0 1 62.4 46.871c.16 6.17-3.033 12.793-8.538 17.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__t)",
    d: "M39.604 24.897c2.574 4.546 4.088 9.08 3.272 13.299-1.183 6.11-4.8 10.821-8.647 14.783-4.802 4.946-5.619 12.409-1.849 17.098q.477.102.964.19a34 34 0 0 0 5.146.513q.229.007.456.007a22.73 22.73 0 0 0 14.916-6.206c5.505-4.916 8.698-11.538 8.538-17.71 0 0-3.413 12.858-14.834 12.858s-1.469-11.502-.634-15.355c2.664-12.309-7.328-19.477-7.328-19.477",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e03616",
    d: "M30.645 58.974a14.7 14.7 0 0 1 2.567-5.123c.597-.77 1.286-1.438 1.906-2.153a45 45 0 0 0 1.83-2.183 27 27 0 0 0 5.226-9.942 13.4 13.4 0 0 0 .466-5.532 21.8 21.8 0 0 0-1.5-5.421 33 33 0 0 0-1.18-2.585c-.428-.842-.909-1.68-1.304-2.559a16.9 16.9 0 0 1-1.507-5.53 18 18 0 0 0 1.834 5.373c.423.848.921 1.653 1.39 2.497.468.84.895 1.702 1.291 2.581a20.3 20.3 0 0 1 1.644 5.559 14.1 14.1 0 0 1-.42 5.807 26.7 26.7 0 0 1-5.5 10.109 45 45 0 0 1-1.928 2.141c-.657.704-1.362 1.348-1.968 2.065a15.4 15.4 0 0 0-2.847 4.896"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__h)",
    d: "M68.1 69.602a92.25 92.25 0 0 0-62.736 0 1.48 1.48 0 0 1-1.892-1.127L.075 56.353a1.834 1.834 0 0 1 .987-2.228 104.44 104.44 0 0 1 71.34 0 1.834 1.834 0 0 1 .988 2.228l-3.397 12.122a1.48 1.48 0 0 1-1.892 1.127"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__u)",
    d: "M68.555 68.702a.6.6 0 0 1-.205-.037 92.98 92.98 0 0 0-63.236 0 .6.6 0 0 1-.205.037.68.68 0 0 1-.633-.53L.88 56.05a.9.9 0 0 1 .043-.608.7.7 0 0 1 .39-.381 103.72 103.72 0 0 1 70.838 0 .7.7 0 0 1 .39.381.9.9 0 0 1 .044.608l-3.397 12.122a.68.68 0 0 1-.633.529"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__v)",
    d: "m37.004 50.86 1.584 3.207a.3.3 0 0 0 .228.166l3.54.514a.304.304 0 0 1 .168.518l-2.561 2.497a.3.3 0 0 0-.088.269l.605 3.525a.304.304 0 0 1-.44.32l-3.167-1.664a.3.3 0 0 0-.282 0l-3.166 1.665a.304.304 0 0 1-.44-.32l.604-3.526a.3.3 0 0 0-.087-.269l-2.562-2.497a.304.304 0 0 1 .168-.518l3.54-.514a.3.3 0 0 0 .229-.166l1.583-3.208a.304.304 0 0 1 .544 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#basis-brand-einbruchschutz_svg__w)",
    d: "M36.732 50.69a.3.3 0 0 1 .272.17l1.584 3.207a.3.3 0 0 0 .228.166l3.54.514a.304.304 0 0 1 .168.518l-2.561 2.497a.3.3 0 0 0-.088.269l.605 3.525a.303.303 0 0 1-.44.32l-3.167-1.664a.3.3 0 0 0-.282 0l-3.166 1.665a.303.303 0 0 1-.44-.32l.604-3.526a.3.3 0 0 0-.087-.269l-2.562-2.497a.304.304 0 0 1 .168-.518l3.54-.514a.3.3 0 0 0 .229-.166l1.583-3.208a.3.3 0 0 1 .272-.169m0-.314a.61.61 0 0 0-.554.344l-1.583 3.208-3.532.508a.618.618 0 0 0-.342 1.055l2.561 2.496-.608 3.516a.617.617 0 0 0 .897.652l3.166-1.665 3.156 1.665a.618.618 0 0 0 .897-.652l-.605-3.525 2.559-2.487a.618.618 0 0 0-.343-1.055l-3.54-.514-1.575-3.202a.61.61 0 0 0-.554-.344",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#bf8364",
    d: "m33.21 61.862.606-3.526a.3.3 0 0 0-.088-.268l-.147-.144a.3.3 0 0 1 .008.107l-.605 3.525a.297.297 0 0 0 .23.34c.001-.013-.005-.022-.003-.034M38.814 54.372a.3.3 0 0 0 .229.167l3.54.514c.01.001.014.009.024.01a.296.296 0 0 0-.251-.316l-3.54-.514a.3.3 0 0 1-.088-.036ZM31.335 55.053l3.54-.514a.3.3 0 0 0 .229-.167l1.583-3.207a.3.3 0 0 1 .402-.134l-.085-.172a.304.304 0 0 0-.544 0l-1.583 3.208a.3.3 0 0 1-.229.166l-3.54.514a.304.304 0 0 0-.168.518l.143.14a.3.3 0 0 1 .252-.352"
  }))));
};
export default SvgBasisBrandEinbruchschutz;